import type { ReactNode } from 'react';

// Thin wrappers over the base typography classes, so screens read like the spec.

/** The screen's one question (h1). `small` for secondary headings on long screens. */
export function Question({
  children,
  small,
  as: As = 'h1',
  id,
}: {
  children: ReactNode;
  small?: boolean;
  as?: 'h1' | 'h2';
  id?: string;
}) {
  return (
    <As className={`q${small ? ' q--sm' : ''}`} id={id}>
      {children}
    </As>
  );
}

export function Sub({ children }: { children: ReactNode }) {
  return <p className="sub">{children}</p>;
}

export function Note({ children, center }: { children: ReactNode; center?: boolean }) {
  return (
    <p className="note" style={center ? { textAlign: 'center' } : undefined}>
      {children}
    </p>
  );
}

/** Help line; `warn` = the gold-edged notice (partial scan, "couldn't find VY6650"). */
export function Hint({ children, warn }: { children: ReactNode; warn?: boolean }) {
  return <p className={`hint${warn ? ' hint--warn' : ''}`}>{children}</p>;
}

/** The honest consequence of "later", stated before the choice (design rule 5). */
export function Why({ children }: { children: ReactNode }) {
  return <p className="why">{children}</p>;
}

export function Eyebrow({ children }: { children: ReactNode }) {
  return <span className="eyebrow">{children}</span>;
}

export function AskTitle({ children }: { children: ReactNode }) {
  return <h2 className="asktitle">{children}</h2>;
}

/** ✅ NO WIN, NO FEE line (S11, S15). */
export function PromiseLine({ children }: { children: ReactNode }) {
  return <p className="promise">{children}</p>;
}

/** ── or ── */
export function OrDivider({ children }: { children: ReactNode }) {
  return (
    <div className="or">
      <span>{children}</span>
    </div>
  );
}
